import { useEffect, useState } from "react";
import { UserInfo } from "@/core/types/types";

export function useUserInfo(): UserInfo | null {
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  useEffect(() => {
    fetch("api/userInfo")
      .then((response) => response.json())
      .then((data) => setUserInfo(data));
  }, []);

  return userInfo;
}
